module.exports = __webpack_public_path__ + "img/footer-icon.d0289dc0.png";